import type { SVGProps } from "react";

export type IconName =
  | "home" | "files" | "edit" | "send" | "clock" | "chart" | "plus" | "search"
  | "globe" | "upload" | "link" | "mic" | "check" | "chevron" | "close" | "play"
  | "pause" | "back" | "forward" | "download" | "mail" | "settings" | "more"
  | "folder" | "tag" | "trash" | "undo" | "redo" | "warning" | "wave";

const paths: Record<IconName, React.ReactNode> = {
  home: <><path d="M3.5 10.8 12 3.7l8.5 7.1v9.1a1.1 1.1 0 0 1-1.1 1.1H4.6a1.1 1.1 0 0 1-1.1-1.1z"/><path d="M9 21v-6.5h6V21"/></>,
  files: <><path d="M4 4.5h6l2 2H20v13H4z"/><path d="M4 9h16"/></>,
  edit: <><path d="M4 20h4l11.2-11.2-4-4L4 16z"/><path d="m13.9 6.1 4 4"/></>,
  send: <><path d="m21 3-7.2 18-3.5-7.3L3 10.2z"/><path d="M10.3 13.7 21 3"/></>,
  clock: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/></>,
  chart: <path d="M4 20V9m6 11V4m6 16v-7m4 7H2"/>,
  plus: <path d="M12 5v14M5 12h14"/>, search: <><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/></>,
  globe: <><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c3.8 4.2 3.8 13.8 0 18M12 3c-3.8 4.2-3.8 13.8 0 18"/></>,
  upload: <><path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5"/><path d="M4 15v5h16v-5"/></>,
  link: <><path d="m9 15 6-6"/><path d="M7 17H5a4 4 0 0 1 0-8h4M17 7h2a4 4 0 1 1 0 8h-4"/></>,
  mic: <><rect x="8" y="3" width="8" height="12" rx="4"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3m-4 0h8"/></>,
  check: <path d="m5 12.5 4.2 4.2L19.5 6.5"/>, chevron: <path d="m9 6 6 6-6 6"/>,
  close: <path d="M5 5l14 14M19 5 5 19"/>, play: <path d="m8 5 11 7-11 7z"/>, pause: <path d="M8 5v14m8-14v14"/>,
  back: <><path d="m9 7-5 5 5 5"/><path d="M4 12h10a6 6 0 0 1 6 6"/></>,
  forward: <><path d="m15 7 5 5-5 5"/><path d="M20 12H10a6 6 0 0 0-6 6"/></>,
  download: <><path d="M12 4v12m0 0 4-4m-4 4-4-4"/><path d="M4 20h16"/></>,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m4 7 8 6 8-6"/></>,
  settings: <><circle cx="12" cy="12" r="3"/><path d="M12 3v2m0 14v2M3 12h2m14 0h2M5.6 5.6 7 7m10 10 1.4 1.4M18.4 5.6 17 7M7 17l-1.4 1.4"/></>,
  more: <><circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/></>,
  folder: <path d="M3.5 6.5h6l2 2h9v11h-17z"/>, tag: <path d="M4 4h7l9 9-7 7-9-9zM8 8h.01"/>,
  trash: <><path d="M4 7h16M9 3h6l1 4H8zM6 7l1 14h10l1-14M10 11v6m4-6v6"/></>,
  undo: <><path d="m9 7-5 5 5 5"/><path d="M4 12h10a6 6 0 0 1 6 6"/></>,
  redo: <><path d="m15 7 5 5-5 5"/><path d="M20 12H10a6 6 0 0 0-6 6"/></>,
  warning: <><path d="m12 3 10 18H2z"/><path d="M12 9v5m0 3h.01"/></>,
  wave: <path d="M3 12h2m2-5v10m3-14v18m3-13v8m3-11v14m3-7h2"/>,
};

export function Icon({ name, ...props }: { name: IconName } & SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>{paths[name]}</svg>;
}
